// extracted by mini-css-extract-plugin
module.exports = {"audioItem":"AudioItem_audioItem__zjKev","trimBlock":"AudioItem_trimBlock__1JPMF"};